import { create } from 'zustand';
import {
  StudentRankingDTO,
  LeaderboardDTO,
  DailyStreakDTO,
  XPBoostDTO,
  XPTransactionDTO,
} from '@/features/ranking/application/dto/RankingDTO';

interface RankingState {
  // Current user ranking
  currentRanking: StudentRankingDTO | null;
  isLoadingRanking: boolean;

  // Leaderboard
  leaderboard: LeaderboardDTO | null;
  isLoadingLeaderboard: boolean;

  // Streak
  streak: DailyStreakDTO | null;
  isLoadingStreak: boolean;

  // Boost
  boost: XPBoostDTO | null;
  isLoadingBoost: boolean;

  // Recent XP transactions
  recentTransactions: XPTransactionDTO[];

  // Error state
  error: string | null;

  // Actions
  setCurrentRanking: (ranking: StudentRankingDTO | null) => void;
  setLeaderboard: (leaderboard: LeaderboardDTO | null) => void;
  setStreak: (streak: DailyStreakDTO | null) => void;
  setBoost: (boost: XPBoostDTO | null) => void;
  addTransaction: (transaction: XPTransactionDTO) => void;
  setRecentTransactions: (transactions: XPTransactionDTO[]) => void;

  setLoadingRanking: (loading: boolean) => void;
  setLoadingLeaderboard: (loading: boolean) => void;
  setLoadingStreak: (loading: boolean) => void;
  setLoadingBoost: (loading: boolean) => void;

  setError: (error: string | null) => void;
  clearAll: () => void;
}

export const useRankingStore = create<RankingState>((set) => ({
  // Initial state
  currentRanking: null,
  isLoadingRanking: false,
  leaderboard: null,
  isLoadingLeaderboard: false,
  streak: null,
  isLoadingStreak: false,
  boost: null,
  isLoadingBoost: false,
  recentTransactions: [],
  error: null,

  // Actions
  setCurrentRanking: (ranking) => set({ currentRanking: ranking }),
  setLeaderboard: (leaderboard) => set({ leaderboard }),
  setStreak: (streak) => set({ streak }),
  setBoost: (boost) => set({ boost }),

  addTransaction: (transaction) =>
    set((state) => ({
      recentTransactions: [transaction, ...state.recentTransactions].slice(0, 20),
    })),

  setRecentTransactions: (transactions) =>
    set({ recentTransactions: transactions }),

  setLoadingRanking: (loading) => set({ isLoadingRanking: loading }),
  setLoadingLeaderboard: (loading) => set({ isLoadingLeaderboard: loading }),
  setLoadingStreak: (loading) => set({ isLoadingStreak: loading }),
  setLoadingBoost: (loading) => set({ isLoadingBoost: loading }),

  setError: (error) => set({ error }),

  clearAll: () =>
    set({
      currentRanking: null,
      leaderboard: null,
      streak: null,
      boost: null,
      recentTransactions: [],
      error: null,
    }),
}));
